import {
  auth,
  facebookAuthProvider,
  firestore,
  githubAuthProvider,
  googleAuthProvider,
  twitterAuthProvider,
  userRepo,
} from '../../@crema/services/auth/firebase/firebase';
import { FORGET_PASSWORD_EMAIL, UPDATE_AUTH_USER } from '../../types/actions/Auth.actions';
import { AuthType } from '../../shared/constants/AppEnums';
import { AppActions } from '../../types';
import { Dispatch } from 'redux';
import { AuthUser } from '../../types/models/AuthUser';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import { UserRepo, UserModel } from 'types/models/dataAccess/User';
import { authRole } from 'shared/constants/AppConst';
import { createFabmanMember, getFabmanMemberPrivileges } from '@crema/services/apis/fabman';
import { isUserAdmin } from '@crema/utility/DataUtils';

export const onSignUpFirebaseUser = ({
  email,
  password,
  firstName,
  lastName,
  sarsId
}: {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  sarsId: string;
}) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      auth
        .createUserWithEmailAndPassword(email, password)
        .then((data: any) => {

          /*{ model received from firebase auth
  "user": {
    "uid": "CFJ1ZNFwOee0DDUIJrsuA5snSK23",
    "displayName": null,
    "photoURL": null,
    "email": "amar.a.ntine.a@gmail.com",
    "emailVerified": false,
    "phoneNumber": null,
    "isAnonymous": false,
    "tenantId": null,
    "providerData": [{
      "uid": "amar.a.ntine.a@gmail.com",
      "displayName": null,
      "photoURL": null,
      "email": "amar.a.ntine.a@gmail.com",
      "phoneNumber": null,
      "providerId": "password"
    }],
    "apiKey": "AIzaSyCQD7hpQtnLSF8svUJUG0Yn0do8fKIWjTI",
    "appName": "[DEFAULT]",
    "authDomain": "virtual-tc.firebaseapp.com",
    "stsTokenManager": {
      "apiKey": "AIzaSyCQD7hpQtnLSF8svUJUG0Yn0do8fKIWjTI",
      "refreshToken": "AGEhc0DtTIHpnH729yDHKxptbw9URV0CY3fjODMr-Ma6km8wKOu7M02WtmDsD3_YctEl7lPFXgE-B90wZ0p0stFoRTv4HfRBayPHaCHWcZMe2A6fPGFyjIna1UknVQ1r4ThTNGq2uYvxt1VoGlnlazdIR9A-1CD0VajHKEGdTiEgoRC6EEuhkmihF3inCKwcsczVVP5jQB6o-eZ2eMyUZ79ORAQsoZpBbg",
      "accessToken": "eyJhbGciOiJSUzI1NiIsImtpZCI6IjMwMjUxYWIxYTJmYzFkMzllNDMwMWNhYjc1OTZkNDQ5ZDgwNDI1ZjYiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vdmlydHVhbC10YyIsImF1ZCI6InZpcnR1YWwtdGMiLCJhdXRoX3RpbWUiOjE2MjI4MjY2MjAsInVzZXJfaWQiOiJDRkoxWk5Gd09lZTBERFVJSnJzdUE1c25TSzIzIiwic3ViIjoiQ0ZKMVpORndPZWUwRERVSUpyc3VBNXNuU0syMyIsImlhdCI6MTYyMjgyNjYyMCwiZXhwIjoxNjIyODMwMjIwLCJlbWFpbCI6ImFtYXIuYS5udGluZS5hQGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJhbWFyLmEubnRpbmUuYUBnbWFpbC5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.LFz5yWu_nQpxEC-fZanTUoRQOpOUxdLjqpZRNcw_r_OkpwEHLTIkVd4qxCW-3geGirnmaa3uBEtSD1u_ClgHEkQYfvFAlAdR13tSphiT-puSpFTtMtE9a1TT73gsKK83Yzr7w5RbUhLsEC9rrtcbdqk4M-JTrfiT3gY-4HZRBVXvBfzgtPan6OTdy9xSzQNqufgrZsWQar7LrDjFivmY9jIVExA728dn54tI-Kx_VD9vgauRFyhkijHetzolmLQ-GTEDkVY4HYkX1da1TpA85JG5eMHk3MRbw9WmqWCQtTDsV7yLmhdaGvXuFiLqX-4S0Wu1uNl1MuEBUtKuf_bpKg",
      "expirationTime": 1622830220000
    },
    "redirectEventId": null,
    "lastLoginAt": "1622826619973",
    "createdAt": "1622826619973",
    "multiFactor": {
      "enrolledFactors": []
    }
  },
  "credential": null,
  "additionalUserInfo": {
    "providerId": "password",
    "isNewUser": true
  },
  "operationType": "signIn"
} */
          let user: UserModel = {
            id: data.user.uid,
            email: data.user.email,
            firstName: firstName,
            lastName: lastName,
            sarsId: sarsId,
            authType: AuthType.FIREBASE,
            createdOn: new Date(),
            createdBy: data.user.uid,
            lastUpdatedOn: new Date(),
            lastUpdatedBy: data.user.uid
          }


          userRepo.create(user).then(createdUser => {

            createFabmanMember(createdUser).then(async fabmanMember => {

              console.log(`[st] user created for ${JSON.stringify(createdUser)} ------ ${JSON.stringify(fabmanMember)}`);

              createdUser.fabmanMember = fabmanMember;
              await firestore.doc(`/users/${user.id}`).set({ fabmanMember: JSON.parse(JSON.stringify(fabmanMember)), member: fabmanMember.id || '' }, { merge: true });
              dispatch(fetchSuccess());
              dispatch({ type: UPDATE_AUTH_USER, payload: getUserObject(data.user, createdUser) });
            })


          });

        })
        .catch(error => {

          console.error(error);
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {

      console.error(error);
      dispatch(fetchError(error?.message));
    }
  };
};

export const onForgetPasswordFirebaseUser = (email: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      auth
        .sendPasswordResetEmail(email)
        .then(data => {
          dispatch(fetchSuccess());
          dispatch({ type: FORGET_PASSWORD_EMAIL, payload: email });
        })
        .catch(error => {
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {
      dispatch(fetchError(error?.message));
    }
  };
};

export const onGetFirebaseSignInUser = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      // auth
      //   .onAuthStateChanged()
      //   .then((authUser: any) => {
      //     dispatch(fetchSuccess());
      //     dispatch({
      //       type: UPDATE_AUTH_USER,
      //       payload: getUserObject(authUser),
      //     });
      //   })
      //   .catch((error: any) => {
      //     dispatch(fetchError(error?.message));
      //   });
    } catch (error: any) {
      dispatch(fetchError(error?.message));
    }
  };
};

export const getUserObject = (authUser: any, userModel: UserModel): AuthUser => {



  // createFabmanMember(userModel);


  // userRepo.get(authUser.uid).then(user => {
  return {
    authType: AuthType.FIREBASE,
    uid: authUser.uid,
    displayName: authUser.displayName,
    email: authUser.email,
    role: authRole.user,
    photoURL: authUser.photoURL,
    token: authUser.refreshToken,
    userProfile: userModel
  };
  // }).catch(error => {
  //   console.error(error);
  //   throw new Error("Something went wrong getting user data. Please refresh the page");
  // });
  // return <AuthUser>{};
};

export const onSignInFirebaseUser = (email: string, password: string) => {
  return (dispatch: Dispatch<AppActions>) => {
    try {
      dispatch(fetchStart());


      auth
        .signInWithEmailAndPassword(email, password)
        .then(data => {

          data.user && userRepo.get(data.user.uid).then(async user => {

            dispatch(fetchSuccess());
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: getUserObject(data.user, user),
            });
          })
        })
        .catch(error => {


          console.error(error);
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {

      console.error(error);
      dispatch(fetchError(error?.message));
    }
  };
};

export const onSignOutFirebaseUser = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {



      auth
        .signOut()
        .then(data => {
          dispatch(fetchSuccess());

          dispatch({ type: UPDATE_AUTH_USER, payload: null });
        })
        .catch(error => {

          console.error(error);
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {

      console.error(error);
      dispatch(fetchError(error?.message));
    }
  };
};

export const signInUserWithGoogle = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      auth
        .signInWithPopup(googleAuthProvider)
        .then(data => {
          data.user && userRepo.get(data.user.uid).then(user => {
            dispatch(fetchSuccess());
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: getUserObject(data.user, user),
            });
          })
        })
        .catch(error => {
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {
      dispatch(fetchError(error?.message));
    }
  };
};
export const signInUserWithGithub = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      auth
        .signInWithPopup(githubAuthProvider)
        .then(data => {
          data.user && userRepo.get(data.user.uid).then(user => {
            dispatch(fetchSuccess());
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: getUserObject(data.user, user),
            });
          })
        })
        .catch(error => {
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {
      dispatch(fetchError(error?.message));
    }
  };
};

export const signInUserWithFacebook = () => {
  return (dispatch: Dispatch<AppActions>) => {
    dispatch(fetchStart());
    try {
      auth
        .signInWithPopup(facebookAuthProvider)
        .then(data => {
          data.user && userRepo.get(data.user.uid).then(user => {
            dispatch(fetchSuccess());
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: getUserObject(data.user, user),
            });
          })
        })
        .catch(error => {
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {
      dispatch(fetchError(error?.message));
    }
  };
};

export const signInUserWithTwitter = () => {
  return (dispatch: Dispatch<AppActions>) => {
    // dispatch(fetchStart());
    try {
      auth
        .signInWithPopup(twitterAuthProvider)
        .then(data => {
          data.user && userRepo.get(data.user.uid).then(user => {
            dispatch(fetchSuccess());
            dispatch({
              type: UPDATE_AUTH_USER,
              payload: getUserObject(data.user, user),
            });
          })
        })
        .catch(error => {
          dispatch(fetchError(error?.message));
        });
    } catch (error: any) {
      dispatch(fetchError(error?.message));
    }
  };
};
